import(/* webpackMode: "eager" */ "/app/app/portfolio/page.tsx");
